<template>
    <div v-if="model && form">
        <rkm-area
            type="fieldset"
            title="Filtros"
        >
        <rkm-form
            show-legend
            ref="Form"
        >
            <rkm-row>
                <rkm-col>
                    <rkm-form-date-picker
                        label="Data"
                        v-model="model.data"
                        :validations="validations.data"
                    />
                </rkm-col>

                <rkm-col>
                    <rkm-form-select
                        label="Unidade"
                        :options="form.unidades"
                        v-model="model.unidadeId"
                        :validations="validations.unidadeId"
                        text-field="nomeFantasia"
                        value-field="id"
                        show-default-option
                    />
                </rkm-col>

                <rkm-col>
                    <rkm-form-select
                        label="Especialidade"
                        :options="form.especialidades"
                        v-model="model.especialidadeId"
                        :validations="validations.especialidadeId"
                        text-field="nome"
                        value-field="id"
                        show-default-option
                    />
                </rkm-col>

                <rkm-col>
                    <rkm-form-select
                        label="Médico"
                        :options="form.usuarios"
                        v-model="model.usuarioId"
                        :validations="validations.usuarioId"
                        text-field="nome"
                        value-field="id"
                        show-default-option 
                    />
                </rkm-col>

                <rkm-col>
                    <rkm-button
                        :label="false"
                        color="secondary"
                        @click="clearForm"
                    >
                        Limpar
                    </rkm-button>

                    <rkm-button
                        :label="false"
                        color="primary"
                        @click="list"
                    >
                        Buscar
                    </rkm-button>
                </rkm-col>
            </rkm-row>
        </rkm-form>
        </rkm-area>

        <rkm-area
            type="fieldset"
            title="Lista de consultas agendadas"
            v-if="items.length > 0"
        >
            <rkm-row>
                <rkm-col>
                    <rkm-button
                        @click="selecionarTodos"
                        color="primary"
                        class="mb-2"
                    >
                        Selecionar todos
                    </rkm-button>

                    <rkm-button
                        @click="selecionarNenhum"
                        color="secondary"
                        class="mb-2"
                    >
                        Desmarcar selecionado(s)
                    </rkm-button>
                </rkm-col>
            </rkm-row>

            <rkm-table
                :fields="fields"
                :items="items"
                hide-filters
                hide-pagination
            >
                <template v-slot:cell(checkbox)="{ item }">
                    <rkm-form-checkbox
                        v-model="item.selecionado"
                    />
                </template>

                <template v-slot:cell(status)="{ item }">
                    {{ item.selecionado ? 'AGENDADO' : item.status }}
                </template>
            </rkm-table>
        </rkm-area>
    </div>
</template>

<script>
import { error, repository } from '@/mixins'
import { mapActions } from 'vuex'
import moment from 'moment'

export default {
    created() {
        this.repositories = {
            alteracaoConsultasFinalizacas: this.getConectaSusRepository('ambulatorio.alteracaoConsultasFinalizadas'),
        }
        this.load()
    },
    data: () => ({
        model: null,
        form: null,
        items: []
    }),
    computed: {
        validations() {
            return {
                data: {
                    required: true
                },
                unidadeId: {
                    required: true
                },
                especialidadeId: {
                    required: true
                },
                usuarioId: {
                    required: true
                }
            }
        },
        fields() {
            return [
                {
                    key: 'checkbox',
                    label: '#',
                    class: 'col-min text-center',
                },
                {
                    key: 'nome',
                    label: 'Nome',
                    sortable: true,
                },
                {
                    key: 'prontuario',
                    label: 'Prontuario',
                    sortable: true,
                },
                {
                    key: 'status',
                    label: 'Status'
                }
            ]
        }
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            this.setLoading()
            this.repositories.alteracaoConsultasFinalizacas.index()
                .then(({ data }) => {
                    this.model = data.model
                    this.form = data.form
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getUnidades() {
            this.setLoading()
            this.repositories.alteracaoConsultasFinalizacas.getUnidades({
                data: moment(this.model.data).format('YYYY-MM-DD')
            })
                .then(({ data }) => {
                    this.form.unidades = data
                    this.model.unidadeId = null
                    if(data.length == 1) {
                        this.model.unidadeId = data[0].id
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getEspecialidades() {
            this.setLoading()
            this.repositories.alteracaoConsultasFinalizacas.getEspecialidades({
                data: moment(this.model.data).format('YYYY-MM-DD'),
                unidade_id: this.model.unidadeId
            })
                .then(({ data }) => {
                    this.form.especialidades = data
                    this.model.especialidadeId = null
                    if(data.length == 1) {
                        this.model.especialidadeId = data[0].id
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getUsuarios() {
            this.setLoading()
            this.repositories.alteracaoConsultasFinalizacas.getUsuarios({
                data: moment(this.model.data).format('YYYY-MM-DD'),
                unidade_id: this.model.unidadeId,
                especialidade_id: this.model.especialidadeId
            })
                .then(({ data }) => {
                    this.form.usuarios = data
                    this.model.usuarioId = null
                    if(data.length == 1) {
                        this.model.usuarioId = data[0].id
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        list() {
            this.$refs.Form.validate()
                .then(valid => {
                    if(valid) {
                        this.setLoading()
                        this.repositories.alteracaoConsultasFinalizacas.list({
                            data: moment(this.model.data).format('YYYY-MM-DD'),
                            unidade_id: this.model.unidadeId,
                            especialidade_id: this.model.especialidadeId,
                            usuario_id: this.model.usuarioId
                        })
                            .then(({ data }) => {
                                this.items = data
                            })
                            .catch(this.handleError)
                            .finally(() => this.unsetLoading())
                    }
                })
        },
        save(){
            if(this.items.filter(item => item.selecionado).length > 0) {
                this.setLoading()
                this.repositories.alteracaoConsultasFinalizacas.store(
                    this.items.filter(item => item.selecionado).map(item => item.id)
                )
                    .then(() => {
                        this.showSaveNotification()
                        this.clearForm()
                        this.$nextTick().then(() => this.$refs.Form.resetValidator())
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        clearForm() {
            this.items = []
            this.model.data = null
            this.model.unidadeId = null
            this.model.especialidadeId = null
            this.model.usuarioId = null
            this.$nextTick().then(() => this.$refs.Form.resetValidator())
        },
        selecionarTodos(){
            this.items = this.items.map(item => {
                item.selecionado = true
                return item
            })
        },
        selecionarNenhum() {
            this.items = this.items.map(item => {
                item.selecionado = false
                return item
            })
        }
    },
    watch: {
        'model.data': function() {
            if(this.model.data) {
                this.model.unidadeId = null
                this.model.especialidadeId = null
                this.model.usuarioId = null
                this.form.especialidades = []
                this.form.usuarios = []
                this.getUnidades()
            }
        },
        'model.unidadeId': function() {
            if(this.model.unidadeId) {
                this.model.especialidadeId = null
                this.model.usuarioId = null
                this.form.usuarios = []
                this.getEspecialidades()
            }
        },
        'model.especialidadeId': function() {
            if(this.model.especialidadeId) {
                this.model.profissionalId = null
                this.getUsuarios()
            }
        }
    },
    mixins: [ error, repository ]
}
</script>